import { debounce } from 'lodash'
import slugify from 'slugify'

export const getSlug = (val: string, replacement = '_', lower = false) => {
  const slug = val
    .split('-')
    .map((part) =>
      slugify(part, {
        replacement,
        strict: true,
        lower,
      })
    )
    .join('-')

  if (!lower) {
    return slug.toUpperCase()
  }

  return slug
}

export const setSlugField = debounce(async (n: string, setFieldValue: any) => {
  const s = (n && getSlug(n)) || ''
  setFieldValue('slug', s)
}, 300)
